import {
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";
import { cx } from "@/utils/classes.utils";
import type { MenuCtx, ResponsiveMenuItem } from "./types.ts";

export function DesktopItem<T extends string>({
  item,
  ctx,
}: {
  item: ResponsiveMenuItem<T>;
  ctx: MenuCtx;
}) {
  switch (item.type) {
    case "separator":
      return <DropdownMenuSeparator />;
    case "label":
      return (
        <DropdownMenuLabel className="p-0 font-normal">
          {item.content}
        </DropdownMenuLabel>
      );
    case "action":
      return (
        <DropdownMenuItem
          disabled={item.disabled}
          className={cx(
            "cursor-pointer disabled:cursor-not-allowed",
            item.destructive && "text-destructive focus:text-destructive",
          )}
          onSelect={(e) => {
            e.preventDefault();
            void item.onSelect(ctx);
          }}
        >
          {item.icon ? (
            <span className="mr-2 inline-flex">{item.icon}</span>
          ) : null}
          {item.label}
        </DropdownMenuItem>
      );
    case "radio-group":
      return (
        <div className="min-w-44">
          {item.label ? (
            <div className="px-2 py-1.5 text-xs font-medium text-muted-foreground">
              {item.label}
            </div>
          ) : null}
          <DropdownMenuRadioGroup
            value={item.value}
            onValueChange={(v) => void item.onValueChange(v as T, ctx)}
          >
            {item.options.map((opt) => (
              <DropdownMenuRadioItem key={opt.value} value={opt.value}>
                {opt.label}
              </DropdownMenuRadioItem>
            ))}
          </DropdownMenuRadioGroup>
        </div>
      );
    // Nested pages inside desktop submenus can be supported too, but let's keep it simple for now:
    case "page":
      return null;
    default:
      return null;
  }
}
